import axios from 'axios';
import qs from 'qs';

let baseURL = 'http://qtadmin.ynbzde.com';

const request = axios.create({
    baseURL: baseURL,
    transformRequest: [
        function(data) {
            return qs.stringify(data);
        }
    ],
    timeout: 5000
});

request.interceptors.response.use(
    response => {
        if ([1, 200].includes(response.data.code * 1)) {
            return response.data;
        } else {
            return Promise.reject(response.data);
        }
    },
    error => {
        return Promise.reject('网络繁忙，请稍后再试');
    }
);

// 下面是HTTP队列的模式
/**
 * 创建一个AXIOS对象
 */
function buildAxiosObj() {
    const request = axios.create({
        baseURL: 'http://116.62.193.17:3333',
        transformRequest: [
            function(data) {
                return qs.stringify(data);
            }
        ],
        timeout: 30000
    });
    return request;
}
async function post(url, data) {
    const req = buildAxiosObj();
    const reData = await req.post('/send', {
        url: baseURL + url,
        query: JSON.stringify({}),
        body: JSON.stringify(data),
        method: 'POST'
    });
    if (reData.data.code === 1) {
        return reData.data;
    } else {
        throw reData.data.msg;
    }
}
async function get(url) {
    const req = buildAxiosObj();
    const reData = await req.post('/send', {
        url: baseURL + url,
        query: JSON.stringify({}),
        body: JSON.stringify({}),
        method: 'GET'
    });
    if (reData.data.code === 1) {
        return reData.data;
    } else {
        throw reData.data.msg;
    }
}
// export default {
//     get,
//     post
// };
export default request;
